<template>
    <div class="collection border-bottom">
        <div class="collection__inner pt-2">


            <div class="row mt-3 mt-md-6">
                <div class="col-lg-4 d-none d-lg-block d-xl-none mb-3">
                    <a :href="pack.link" class="no-link"><img class="img-fluid" :src="imgSrc" alt=""></a>
                </div>

                <div class="col-10 col-md-10 col-lg-5 col-xl-4 pr-sm-5 pr-xl-1 mb-2 mb-md-0">
                    <a :href="pack.link" class="no-link">
                        <div class="title">{{pack.name}} <img v-if="pack.titleImg" :src="pack.titleImg" :alt="pack.name" class="img-fluid img-kids-collection-title"></div>
                        <p>{{pack.fabric}}</p>
                    </a>
                </div>
                <div class="col-2 ml-auto d-lg-flex justify-content-end text-right">
                    <div class="title d-none d-lg-block text-nowrap text-transform-initial">{{$nf(totalDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                    <div class="orderRow__item orderRow__item--remove">
                        <remove-button @submit="removeItemPack"></remove-button>
                    </div>
                </div>


            </div>

            <div class="row">
                <div class="col-xl-4 d-block d-lg-none d-xl-block mb-3 mb-lg-0">
                    <a :href="pack.link" class="no-link">
                        <img class="img-fluid" :src="imgSrc" alt="">
                    </a>
                </div>
                <div class="col-xl-8 col-xxl-8">
                    <basket-pack-item :item="item" :key="item.id" v-for="item in items" @setItemQuantity="setItemQuantity"></basket-pack-item>
                </div>
                <div class="col-12 d-lg-none pt-3 text-right">
                        <div class="title text-nowrap text-transform-initial">{{$nf(totalDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RemoveButton from "./RemoveButton";
    import BasketPackItem from "./BasketPackItem";

    export default {
        data: function () {
            return {
                isOpen: true,
                showConfirmDeletePopup: false
            };
        },
        props: ["pack"],
        computed: {
            items: function () {
                return this.pack.items;
            },
            imgSrc() {
                // big w500px, small w200px
                return this.pack.image.big;
            },
            priceWithVat: function () {
                return this.pack.price.priceWithVat;
            },
            discountPriceWithVat: function () {
                return this.pack.discountPrice.priceWithVat;
            },
            totalPriceWithVat: function () {
                return this.pack.totalPrice.priceWithVat;
            },
            totalDiscountPriceWithVat: function () {
                return this.pack.totalDiscountPrice.priceWithVat;
            },
            currency: function () {
                return this.pack.price.currency.htmlString;
            },
            currencyCode: function () {
                return this.pack.price.currency.code;
            },
            productSetName: function () {
                if (this.pack.productSet) {
                    return this.pack.productSet.name;
                }
                return '';
            },
            productSetTypeIdentifier: function () {
                if (this.pack.productSet) {
                    return this.pack.productSet.productSetType.identifier;
                }
                return '';
            },
            productSetTypeName: function () {
                if (this.pack.productSet) {
                    return this.pack.productSet.productSetType.name;
                }
                return '';
            },
            hasGifts: function () {
                return this.pack.gifts.length > 0;
            },
            gifts: function () {
                return this.pack.gifts;
            },
            pillowSmallCount: function () {
                return this.countBasketItemByTypeAndTPValue('pillow', 1069, 40783);
            },
            pillowRegularCount: function () {
                return this.countBasketItemByTypeAndTPValue('pillow', 1069, 40784);
            },
            pillowLargeCount: function () {
                return this.countBasketItemByTypeAndTPValue('pillow', 1069, 40785); // at least one
            },
            duvetRegularCount: function () {
                return this.countBasketItemByTypeAndTPValue('duvet', 1074, 40795); // at least one
            },
            duvetDoubleCount: function () {
                return this.countBasketItemByTypeAndTPValue('duvet', 1074, 40796); // at least one
            },
            sheetCount: function () {
                return this.countBasketItemByType('sheet');
            },
        },

        mounted: function () {


        },

        methods: {
            setItemQuantity: function (data) {
                data['configuratorUid'] = this.pack.configuratorUID;
                this.$store.dispatch('changeBasketItemQuantity', data)
                    .then(function()  {
                        $('#basket-hidden-update').trigger('click');
                    });
            },
            setPackQuanitity: function (value) {
                if (value <= 0) {
                    this.openConfirmDeletePopup();
                } else {
                    const payload = {
                        uid: this.pack.uid,
                        quantity: value
                    };
                    this.$store.dispatch('changeBasketPackQuantity', payload);
                }
            },
            removeItemPack: function () {
                this.$store.dispatch('removeItemPack', {
                    uid: this.pack.uid
                }).then(() => {
                    setTimeout(function () {
                      $('#basket-update').trigger('click');
                    }, 1000);
                });
            },
            toggleOpen: function () {
                this.isOpen = !this.isOpen;
            },
            editConfigurator: function () {
                this.$store.dispatch("editConfigurator", {uid: this.pack.uid});
            },
            countBasketItemByType: function (productTypeCode) {
                var filteredItems = this.pack.items.filter(function (basketItem) {
                    return basketItem.productType.code == productTypeCode;
                });
                var quantity = 0;
                filteredItems.forEach(function (item) {
                    quantity += item.quantity;
                });
                return quantity
            },
            // by Type and technical param value
            countBasketItemByTypeAndTPValue: function (productTypeCode, technicalParamId, technicalParamValueId) {
                var filteredItems = this.pack.items.filter(function (basketItem) {
                    if (basketItem.isCustom) {
                        return false;
                    }
                    let sizeTP = basketItem.technicalParameters.find(function (tp) {
                        return tp.id == technicalParamId;
                    });
                    return basketItem.productType.code == productTypeCode
                        && sizeTP
                        && sizeTP.value.id == technicalParamValueId;
                });
                var quantity = 0;
                filteredItems.forEach(function (item) {
                    quantity += item.quantity;
                });
                return quantity
            },
            openConfirmDeletePopup() {
                this.showConfirmDeletePopup = true;
            },
            submitDelete() {
                this.showConfirmDeletePopup = false;
                this.removeItemPack();
            },
            closeConfirmDeletePopup() {
                this.showConfirmDeletePopup = false;
                this.pack.quantity = 1;
            },
        },

        // SVGs imported as components by vue-svg-loader
        components: {
            BasketPackItem,
            RemoveButton,
        },
    };


    /*
    pro obrázek: .js-bed-variable-double
    jsou nachystané třídy:

    .has-pillow-small-left
    .has-pillow-regular-left
    .has-pillow-large-left
    .has-pillow-small-right
    .has-pillow-regular-right
    .has-pillow-large-right
    .has-duvet
    .has-cover
     */
</script>
